import { render, staticRenderFns } from "./UserFiltersSave.vue?vue&type=template&id=c3cba408"
import script from "./UserFiltersSave.vue?vue&type=script&lang=js"
export * from "./UserFiltersSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports